var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"categoryList"},_vm._l((_vm.listadecategorias),function(categoria){return _c('Categoria',{key:categoria.idcategoriaprod,attrs:{"categoria":categoria,"idpdv":_vm.idpdv}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }